// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"bf56b4c4","312":"9fb0152f","391":"7641fb60","575":"92e6bc8d","863":"5a5b916b","905":"bbbe774a"}[chunkId] + ".chunk.js";
};